// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Background Layer */
.background-layer {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: hidden; /* Hide any overflow */
    /* Set the height to the full height of the document */
    height: 100%;
}

/* Base Styles for Lights */
.light {
    filter: blur(125px);
    border-radius: 50%;
    position: absolute;
    transition: transform 4s ease-in-out; /* Smooth movement */
    opacity: 0.4;
}

/* Adjustments for Mobile Devices */
@media (max-width: 767px) {
    .light {
        filter: blur(60px); /* Reduced blur for mobile */
        opacity: 1.0;
    }
}

/* Disable transition initially */
.light.no-transition {
    transition: none;
}

/* Enable transition for movement */
.light:not(.no-transition) {
    transition: transform 4s ease-in-out;
}

/* Individual Light Styles */
.light-1 {
    background-color: #e5d694;
}

.light-2 {
    background-color: #cbae2c;
}`, "",{"version":3,"sources":["webpack://./src/Background.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;IACI,eAAe;IACf,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,gBAAgB,EAAE,sBAAsB;IACxC,sDAAsD;IACtD,YAAY;AAChB;;AAEA,2BAA2B;AAC3B;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,oCAAoC,EAAE,oBAAoB;IAC1D,YAAY;AAChB;;AAEA,mCAAmC;AACnC;IACI;QACI,kBAAkB,EAAE,4BAA4B;QAChD,YAAY;IAChB;AACJ;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;AACpB;;AAEA,mCAAmC;AACnC;IACI,oCAAoC;AACxC;;AAEA,4BAA4B;AAC5B;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":["/* Background Layer */\n.background-layer {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    overflow: hidden; /* Hide any overflow */\n    /* Set the height to the full height of the document */\n    height: 100%;\n}\n\n/* Base Styles for Lights */\n.light {\n    filter: blur(125px);\n    border-radius: 50%;\n    position: absolute;\n    transition: transform 4s ease-in-out; /* Smooth movement */\n    opacity: 0.4;\n}\n\n/* Adjustments for Mobile Devices */\n@media (max-width: 767px) {\n    .light {\n        filter: blur(60px); /* Reduced blur for mobile */\n        opacity: 1.0;\n    }\n}\n\n/* Disable transition initially */\n.light.no-transition {\n    transition: none;\n}\n\n/* Enable transition for movement */\n.light:not(.no-transition) {\n    transition: transform 4s ease-in-out;\n}\n\n/* Individual Light Styles */\n.light-1 {\n    background-color: #e5d694;\n}\n\n.light-2 {\n    background-color: #cbae2c;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
